<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="添加项目"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="650px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap pr20 mt20">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="100px">
                <el-form-item label="项目名称：" prop="project_name">
                    <el-input v-model.trim="formItem.project_name" placeholder="请输入项目名称" style="width: 320px;"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="note">
                    <el-input type="textarea" :rows="2" v-model.trim="formItem.note" placeholder="最多可输入50字" style="width: 320px;"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20" v-matomo="{behaviorCategory: '项目管理',name: '添加项目(取消)' }">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '项目管理',name: '添加项目(提交)' }">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/baseInfo/project.js';
    import matomoFun from "@/utils/matomo.js";

    export default {
        name: "AddProjectModal",
        components:{},
        props:{
            data:Object,
        },
        data(){
            return {
                dialogVisible:false,
                formItem:{
                    project_name:'',
                    note:'',
                },
                rules:{
                    project_name:[
                        { required: true, message: '请输入项目名称', trigger: 'blur' },
                    ],
                    note:[
                        { max: 50, message: '最多可输入50字', trigger: 'blur' }
                    ],
                },
                submitLoading:false,
            }
        },
        methods:{
            handleClose(){
                matomoFun.trackEvent('项目管理', '点击', '添加项目(取消)');
                this.resetForm();
                this.dialogVisible = false;
                this.$refs.form.clearValidate();
            },
            showModal(){
                this.dialogVisible = true;
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.submitLoading = true;
                        API.addProject({
                            project_name:this.formItem.project_name,
                            note:this.formItem.note,
                        }).then(res=>{
                            console.log('addProject',res);
                            this.submitLoading = false;
                            this.$message.success(res.info||'操作成功');
                            this.hideModal();
                            this.$emit('update');
                        },err=>{
                            console.log('addProject err',err);
                            this.submitLoading = false;
                            this.$message.error(err.info||'操作失败');
                        })
                    } else {
                        return false;
                    }
                });
            },
            hideModal(){
                console.log('hideModal');
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formItem.project_name = '';
                this.formItem.note = '';
                this.submitLoading = false;
            },

        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-dialog__body{
        padding: 10px 30px 20px;
    }

    ::v-deep .word-limit-input input{
        padding-right: 80px;
    }

</style>
